export const TEACHER_DEMO = 'TEACHER_DEMO';
export const STUDENT_DEMO = 'STUDENT_DEMO';
export const ADMIN_DEMO = 'ADMIN_DEMO';
